import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FormLayout, Select, Form, Icon, Card, OptionList, TextField, Banner, TextStyle, Link } from '@shopify/polaris';

import { ta } from 'utils';
import axios from 'utils/axios-rails';

import BasicTextField from '@shared/BasicTextField';
import DatePicker from '@shared/AppDatePicker';
import TaskDeliveryDetails from './TaskDeliveryDetails';
import MovementRoute from 'components/shared/MovementRoute';

const propTypes = {
  // values: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
}

const defaultProps = {
  readOnly: false,
}

const TaskUpdateForm = ({ renderProps, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [customerOrderItems, setCustomerOrderItems] = useState([]);
  
  const { values } = renderProps;
  const { kinds, teams } = props.catalogs;

  const orderDataExists = !!values.brightpearl_data.order_reference || !!values.brightpearl_data.order_items;

  return (
    <Card>
      <Banner title={ I18n.t(`enum.status.${values.status}`) }></Banner>
      {/* Only sent for a task that belongs to an RMA the user can open, so there is never a dead link. */}
      { values.customer_ticket_link &&
        <Card.Section title="RMA asociado">
          <Link url={ values.customer_ticket_link.url }>{ values.customer_ticket_link.name }</Link>
        </Card.Section>
      }
      <Card.Section title="Información de contacto">
        <FormLayout>
          <TextField
            readOnly
            label={ta("task.kind")}
            value={ I18n.t(`enum.kind.${values.kind}`) }
          />
          
          {/* Fields based on Contact selection */}
          <FormLayout.Group>
            <TextField
              readOnly
              label={ta("general.name")}
              value={ values.brightpearl_data.name }
            />
            <TextField
              readOnly
              label={ta("general.phone")}
              value={ values.brightpearl_data.phone }
              />
          </FormLayout.Group>
          <TextField
            label={ta("general.address")}
            readOnly
            value={ values.address }
          />
        </FormLayout>
      </Card.Section>

      { orderDataExists ? (
        <Card.Section title="Información de la tarea">
          <FormLayout>
            <TextField
              readOnly
              label={ta("task.provider_order_id")}
              value={ String(values.provider_order_id) }
            />
            <FormLayout.Group>
              <TextField
                readOnly
                label="#"
                value={ values.brightpearl_data.order_reference }
              />
              <TextField
                readOnly
                label={ta("general.status")}
                value={ values.brightpearl_data.order_status }
              />
            </FormLayout.Group>
            { values.brightpearl_data.order_items.length > 0 &&
              <OptionList
                title="Productos"
                readOnly
                allowMultiple
                onChange={ () => true }
                options={ values.brightpearl_data.order_items }
                selected={ values.item_ids }
              />
            }
          </FormLayout>
        </Card.Section>
        ) : ( null )
      }
          
      {/* An RMA move says where the courier picks the product up and drops it off; `address` alone cannot. */}
      { values.rma_route &&
        <Card.Section title="Movimiento">
          {/* The route line is the one place that says where to pick up and drop off; the fields below only
              add what it cannot: who owns the case, who to call at the workshop and where the case stands. */}
          <FormLayout>
            <div>
              <TextStyle variation="strong">{ values.rma_route.leg_label }</TextStyle>
              <div className="mt4">
                <MovementRoute movement={ values.rma_route.leg } origin={ values.rma_route.origin } destination={ values.rma_route.destination } withLabels />
              </div>
            </div>
            { values.rma_route.supplier_leg &&
              <FormLayout.Group>
                {/* Only when it adds something: no supplier, or one that is the workshop itself, is already in the route */}
                { values.supplier_case_summary?.supplier && values.supplier_case_summary.supplier !== values.supplier_case_summary.workshop &&
                  <TextField readOnly label="Proveedor del caso" value={ values.supplier_case_summary.supplier } />
                }
                <TextField readOnly label="Contacto del taller" value={ values.rma_route.contact || '—' } />
                <TextField readOnly label="Gestión de Proveedor" value={ values.supplier_case_summary?.status || '—' } />
              </FormLayout.Group>
            }
          </FormLayout>
        </Card.Section>
      }

      <Card.Section title="Información de envío">
        <TaskDeliveryDetails 
          initialCouriers={ props.initialCouriers }
          queryCouriersURL={ props.queryCouriersURL }
          teams={ teams }
          disabled={ props.readOnly }

          polarisFormProps={ renderProps }
        />
      </Card.Section>
    </Card>
  )
};

TaskUpdateForm.propTypes = propTypes;
TaskUpdateForm.defaultProps = defaultProps;

export default TaskUpdateForm;